var map = {
	"./CatalogCarousel/CatalogCarousel.vue": [
		1158,
		168
	],
	"./CatalogCarousel/CatalogItem.vue": [
		1151,
		247
	],
	"./MarketingCards.vue": [
		326
	],
	"./ProductCarousel/CarouselProductItem.vue": [
		1152,
		248
	],
	"./ProductCarousel/ProductCarousel.vue": [
		1159,
		6,
		111
	],
	"./ReorderHighlight/ReorderHighlight.vue": [
		1160,
		172
	],
	"./VoucherCarousel/VoucherCardItem.vue": [
		407
	],
	"./VoucherCarousel/VoucherCarousel.vue": [
		403
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1128;
module.exports = webpackAsyncContext;